<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex d-flex xs12 sm6 md9>
                <v-card color="white">
                  <v-card-title primary class="title grey ">
                    <span>
                      <v-icon large color="white">
                        fiber_manual_record
                      </v-icon>
                    </span>
                    {{aboutNavTitle}}
                  </v-card-title>
                <v-card-title primary class="title">{{ mainInfoTitle }}</v-card-title>
                <v-card-text>
                    <p>{{ mainInfo1 }}</p>
                    <p>{{ mainInfo2 }}</p>
                    <p>{{ mainInfo3 }}</p>
                    <p>{{ mainInfo4 }}</p>
                    <p>{{ mainInfo5 }}</p>
                    <p>{{ mainInfo6 }}</p>
                </v-card-text>
                <v-card-title primary class="title">{{ mainInfoSubTitle }}</v-card-title>
                <v-card-text>
                    <p>{{ mainInfo7 }}</p>
                </v-card-text>
                <!--<v-data-table
                  :items="tabelItems"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <div class="mt-1">
                        <img height="50px" :src="props.item.src" alt="">
                      </div>
                    </td>
                    <td class="text-xs-center">{{ props.item.sponsor }}</td>
                  </template>
                </v-data-table>-->
                </v-card>
            </v-flex>
            <v-flex d-flex xs12 sm6 md3>
                <v-card color="white">
                  <v-card-title primary class="title grey pa-4">
                    {{kontaktInfo1}}
                  </v-card-title>
                <v-card-text>
                    <p>{{ kontaktInfo2a }} {{ kontaktInfo2b }}</p>
                    <p>{{ kontaktInfo3a }}</p>
                    <p>{{ kontaktInfo3b }}</p>
                    <p>{{ kontaktInfo3c }}</p>

                    <p>{{ kontaktInfo4a }}</p>
                    <p>{{ kontaktInfo4b }}</p>
                    <p>{{ kontaktInfo4c }}</p>
                </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import * as dataOfSponsors from './sponsors/sponsors'
  import { mapState, mapGetters } from 'vuex'
  import { EventBus } from '../events'

  export default {
    data: () => {
      return {
        tabelItems: []
      }
    },
    mounted(){
      EventBus.$emit('show', false)

      //this.updateSponsors(this.languageSelected)

      EventBus.$on('language', lang => {
        //this.updateSponsors(lang)
      })
      
    },
    computed: {
        ...mapState('ContactModule', [
            'newsArray', 
            'latestNews', 
            'close',

            'aboutNavTitle',

            'mainInfoTitle',
            'mainInfoSubTitle',
            'mainInfo1',
            'mainInfo2',
            'mainInfo3',
            'mainInfo4',
            'mainInfo5',
            'mainInfo6',
            'mainInfo7',

            'kontaktInfo1',
            'kontaktInfo2a',
            'kontaktInfo2b',
            'kontaktInfo2c',
            'kontaktInfo3a',
            'kontaktInfo3b',
            'kontaktInfo3c',
            'kontaktInfo4a',
            'kontaktInfo4b',
            'kontaktInfo4c',
          ]),
      ...mapGetters('ContactModule', {
        // map `this.doneCount` to `this.$store.getters.doneTodosCount`
        languageSelected: 'language',
      }),
    },
    methods: {
      updateSponsors(val){
        if(val == 'DE'){
          this.tabelItems = dataOfSponsors.data.de
        } else {
          this.tabelItems = dataOfSponsors.data.en
        }
      }
    }
  }
</script>
